'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var reducerTypes = require('./reducerTypes.js');

var createToast = function (toast, state) {
    var updatedToasts = tslib.__spreadArray(tslib.__spreadArray([], state.toasts, true), [toast], false);
    return tslib.__assign(tslib.__assign({}, state), { toasts: updatedToasts });
};
var updateToastTimeout = function (_a, state) {
    var id = _a.id, timeoutId = _a.timeoutId, timeoutStart = _a.timeoutStart, timeoutRemaining = _a.timeoutRemaining;
    var currentToasts = tslib.__spreadArray([], state.toasts, true);
    var updatedToasts = currentToasts.map(function (toast) {
        var updatedToast = toast;
        if (toast.id === id) {
            updatedToast = tslib.__assign(tslib.__assign({}, toast), { timeoutId: timeoutId, timeoutStart: timeoutStart, timeoutRemaining: timeoutRemaining });
        }
        return updatedToast;
    });
    return tslib.__assign(tslib.__assign({}, state), { toasts: updatedToasts });
};
var destroyToast = function (id, state) {
    var currentToasts = tslib.__spreadArray([], state.toasts, true);
    var updatedToasts = id
        ? currentToasts.filter(function (product) { return product.id !== id; })
        : currentToasts.slice(0, -1);
    return tslib.__assign(tslib.__assign({}, state), { toasts: updatedToasts });
};
var toastReducer = function (state, action) {
    switch (action.type) {
        case reducerTypes.ActionTypes.CREATE_TOAST:
            return createToast(action.toast, state);
        case reducerTypes.ActionTypes.UPDATE_TOAST_TIMEOUT:
            return updateToastTimeout(action.toast, state);
        case reducerTypes.ActionTypes.DESTROY_TOAST:
            return destroyToast(action.id, state);
        case reducerTypes.ActionTypes.DESTROY_ALL_TOASTS:
            return tslib.__assign(tslib.__assign({}, state), { toasts: [] });
        default:
            return state;
    }
};

exports.toastReducer = toastReducer;
//# sourceMappingURL=reducers.js.map
